import React from "react";
import { motion } from "framer-motion";
import { Users, BookOpen, Building2, LifeBuoy } from "lucide-react";
import { SERVICE_CARDS, fadeUp } from "../../data";
import { scrollToId } from "./Navbar";

const ICONS = { Users, BookOpen, Building2, LifeBuoy };

export const PublicService = () => {
  return (
    <section id="service" className="relative py-24 md:py-32" style={{ background: "var(--softblue)" }}>
      <div className="container-x">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-14">
          <motion.div variants={fadeUp} initial="hidden" whileInView="show" viewport={{ once: true }} className="lg:col-span-8">
            <span className="eyebrow" style={{ color: "var(--blue)" }}>Public Service</span>
            <h2 className="font-display font-bold tracking-tight text-3xl md:text-4xl lg:text-5xl mt-4" style={{ color: "var(--navy)" }}>
              Every concern deserves to be heard.
            </h2>
            <p className="font-body text-base md:text-lg leading-relaxed mt-6 max-w-2xl" style={{ color: "var(--text2)" }}>
              We believe communities grow stronger when people talk to one another. So this is your direct line — a simple
              place to share what's on your mind, whether it's a worry, an idea, or a request for help.
            </p>
          </motion.div>
          <motion.div variants={fadeUp} initial="hidden" whileInView="show" viewport={{ once: true }} className="lg:col-span-4 lg:text-right">
            <button data-testid="service-cta" onClick={() => scrollToId("#contact")}
              className="btn-primary inline-flex items-center rounded-full font-body font-semibold px-7 py-3.5">
              Send a Message
            </button>
          </motion.div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {SERVICE_CARDS.map((c, i) => {
            const Icon = ICONS[c.icon];
            return (
              <motion.div key={c.title} variants={fadeUp} custom={i} initial="hidden" whileInView="show" viewport={{ once: true }}
                data-testid={`service-card-${i}`}
                className="group bg-white rounded-2xl p-7 border hover:-translate-y-2 hover:shadow-[0_18px_40px_rgba(25,118,210,0.12)] transition-all duration-300 shadow-[0_8px_30px_rgba(0,0,0,0.04)]"
                style={{ borderColor: "var(--grey)" }}>
                <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl mb-5 transition-colors duration-300"
                  style={{ background: "rgba(25,118,210,0.10)" }}>
                  <Icon size={22} color="var(--blue)" />
                </span>
                <h3 className="font-display font-semibold text-lg" style={{ color: "var(--navy)" }}>{c.title}</h3>
                <p className="font-body text-sm leading-relaxed mt-2" style={{ color: "var(--text2)" }}>{c.body}</p>
                <div className="h-0.5 w-0 group-hover:w-12 mt-4 transition-[width] duration-300" style={{ background: "var(--blue)" }} />
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
